import { create, StateCreator } from 'zustand';

import sharedConfigApi from '../../api/sharedConfig';

import { SharedConfigStoreState } from './types';

const initialState: Omit<SharedConfigStoreState, 'actions'> = {
  config: null,
};

const stateCreator: StateCreator<SharedConfigStoreState> = (
  set,
  get
): SharedConfigStoreState => ({
  ...initialState,
  actions: {
    init: async (): Promise<void> => {
      if (get().config) {
        return;
      }

      const response = await sharedConfigApi.index();

      if (response.success) {
        set({ config: response.config });
      }
    },
    reset: (): void => {
      set(initialState);
    },
  },
});

export const useSharedConfigStore = create(stateCreator);
